var $a78bd303005dee59$exports = {};
$a78bd303005dee59$exports = {
    "info": `Info`,
    "negative": `Fout`,
    "positive": `Geslaagd`
};


export {$a78bd303005dee59$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
